// Темп «печатной машинки» для ответа ассистента.
//
// Раньше скорость была константой: 2 символа за тик в 20 мс, то есть жёсткий потолок
// 100 символов в секунду. Ответ на 600 символов рисовался 6 секунд, на 1500 — 15, причём
// НЕЗАВИСИМО от того, как быстро ответил сервер. Это и была жалоба «печатается долго» —
// никакая оптимизация бэкенда её не лечила.
//
// Теперь скорость зависит от глубины буфера: пока текста мало, темп прежний и привычный,
// но при большом отставании анимация ускоряется, чтобы не плестись за сервером.

export const REVEAL_INTERVAL_MS = 20;
// Пол — прежняя скорость: короткие ответы должны выглядеть как раньше.
export const REVEAL_MIN_CHARS_PER_TICK = 2;
// Потолок: быстрее глаз всё равно не читает, а без него один тик вываливал бы весь буфер.
export const REVEAL_MAX_CHARS_PER_TICK = 60;
// За столько тиков стремимся опустошить буфер (40 × 20 мс ≈ 0.8 с).
export const REVEAL_TARGET_DRAIN_TICKS = 40;

/**
 * Сколько символов показать на этом тике при данной глубине буфера.
 * @param {number} pendingLength длина ещё не показанного текста
 * @returns {number} число символов, всегда в пределах [min, max]
 */
export function revealChunkSize(pendingLength) {
  if (!pendingLength || pendingLength <= 0) return REVEAL_MIN_CHARS_PER_TICK;
  const needed = Math.ceil(pendingLength / REVEAL_TARGET_DRAIN_TICKS);
  return Math.max(REVEAL_MIN_CHARS_PER_TICK, Math.min(REVEAL_MAX_CHARS_PER_TICK, needed));
}
